import {
  SoDataTableColumnType,
  SoDataTableHeader,
} from "@/types/components/SoDataTable"

// Builds a sortable date-time column header. Shared by the service-config list
// and history tables, which both render the same set of timestamp columns.
export const dateTimeColumn = (
  title: string,
  key: string,
): SoDataTableHeader => ({
  title,
  key,
  type: SoDataTableColumnType.DATE_TIME,
  sortable: true,
})
